import React from 'react'
import { cn } from '../../../utils/classnames'

const CustomActionButton = ({
  state = 'default', // 'default', 'disabled', 'alter'
  onClick,
  icon: Icon,
  title = '',
  className = '',
  children
}) => {
  const baseClasses = 'px-5 py-2 rounded-full text-xs font-semibold transition duration-200 items-center flex gap-2 justify-center'

  const stateClasses = {
    default: 'bg-tealMedium text-white hover:opacity-90 border-r-2 border-b-2 border-tealBase',
    disabled: 'bg-grayLight text-grayMedium border border-grayBase cursor-not-allowed',
    edit: 'bg-blueExtraLight text-tealDeep border border-tealSoft hover:opacity-80',
    alt: 'bg-white text-blueMedium border border-bluePale hover:opacity-80'
  }

  const isDisabled = state === 'disabled'

  return (
    <button
      disabled={isDisabled}
      onClick={onClick}
      className={cn(baseClasses, stateClasses[state], className)}
      title={title}
    >
      {Icon && <Icon size={14} strokeWidth={1.25}/>}
      {children}
    </button>
  )
}

export default CustomActionButton
